<template>
  <div v-if="showModal">
    <div id="modal" class="modal-mask" transition="modal">
      <div class="modal-container">
        <div style="position: relative;z-index: 111;">
          <div class="modal-popup" @click="hide()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#dae12f"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        </div>
        <div :id="id" style="margin: 0 auto;"></div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
/* eslint-disable */
// import PopupInterstitial from "../ads/popupInterstitial";
export default {
  data() {
    return {
      showModal: false,
      count: 0,
    };
  },
  props: { size: Array, path: String, id: String },
  beforeCreate() {
    if (process.browser) {
      window.googletag = window.googletag || { cmd: [] };

      window.googletag.cmd.push(() => {
        window.googletag.destroySlots();
      });
    }
  },
  methods: {
    hide() {
      this.showModal = false;
      document.body.style.overflow = "auto"; // ADD THIS LINE
      document.body.style.height = "auto"; // ADD THIS LINE
    },
    getAdsDetails() {
      const vm = this;
      const elementId = vm.id;

      vm.showModal = true;

      this.$nextTick(() => {
        window.googletag.cmd.push(() => {
          const existingSlots = window.googletag.pubads().getSlots();
          const matchingSlot = existingSlots.find(
            (slot) => slot.getSlotElementId() === elementId
          );
          if (matchingSlot) {
            window.googletag.destroySlots([matchingSlot]);
          }

          const slot = window.googletag
            .defineSlot(vm.path, vm.size, elementId)
            .addService(window.googletag.pubads())
            .setCollapseEmptyDiv(true);

          window.googletag.pubads().enableSingleRequest();
          window.googletag.enableServices();
          window.googletag.display(elementId);

          window.googletag
            .pubads()
            .addEventListener("slotRenderEnded", function(event) {
              if (event.slot.getSlotElementId() === elementId) {
                if (event.isEmpty) {
                  vm.showModal = false;
                  document.body.style.overflow = "auto";
                  document.body.style.height = "auto";
                } else {
                  vm.showModal = true;
                  document.body.style.overflow = "hidden";
                  document.body.style.height = "100%";
                }
              }
            });

          window.googletag.pubads().refresh([slot]);
        });
      });
    },
  },
  mounted() {
    this.$watch("$refs.popupVisible.style", (new_value, old_value) =>
      console.log("i")
    );
    var vm = this;
    if (vm.path && vm.size && vm.id) {
      this.getAdsDetails();
    }
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: auto;
  max-width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-popup {
  position: absolute;
  right: -14px;
  top: -14px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
